import { useState } from 'react';

import { teamIdSchema, type Team, type TeamId } from '@/core/schemas';
import { Button } from '@/shared/ui/Button';

interface ModeratorBarProps {
  teams: readonly Team[];
  onCallTeam: (teamId: TeamId) => void;
}

/**
 * Moderator controls, shown on the beamer only to a signed-in director.
 *
 * Playing an entrance is a presentation action, not a data change: it only
 * triggers the local walk-on overlay via `onCallTeam`. Assigning boards and
 * calling matches for real stays in the admin area, which the security rules
 * back.
 */
export function ModeratorBar({ teams, onCallTeam }: ModeratorBarProps) {
  const active = teams.filter((team) => team.status === 'active');
  const [selected, setSelected] = useState('');

  return (
    <div className="border-line bg-surface flex flex-wrap items-center gap-3 border-t px-8 py-4">
      <span className="text-fg-subtle text-sm tracking-wide uppercase">Moderation</span>

      <select
        value={selected}
        onChange={(event) => setSelected(event.target.value)}
        className="bg-surface-raised border-line min-w-56 rounded-lg border px-3 py-2 text-sm"
      >
        <option value="">Team wählen …</option>
        {active.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
          </option>
        ))}
      </select>

      <Button
        size="md"
        disabled={selected === ''}
        onClick={() => {
          const parsed = teamIdSchema.safeParse(selected);
          if (parsed.success) {
            onCallTeam(parsed.data);
            setSelected('');
          }
        }}
      >
        Einlaufen abspielen
      </Button>
    </div>
  );
}
